import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    --background: url(/assets/layout-own-ai-dominate/welcome/image.jpg)
      no-repeat center center / cover;
    --padding-bottom: 18px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url(/assets/layout-own-ai-dominate/welcome/overlay-gradient.png)
        no-repeat center center / cover;
      z-index: 1;
      pointer-events: none;
    }

    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url(/assets/layout-own-ai-dominate/welcome/glowing-overlay.png)
        no-repeat center center / cover;
      z-index: 1;
      pointer-events: none;
    }

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      position: relative;
      z-index: 2;
    }

    .app-logo {
      width: 131px;
      height: 30px;
      margin: 0 0 32px;
    }
  }
`;

export const WelcomeBanner = styled.div`
  width: 198px;
  height: 80px;
  background: url(/assets/layout-own-ai-dominate/welcome/header.png) no-repeat
    center center / contain;
  aspect-ratio: 320 / 220;
  position: relative;
  z-index: 3;
`;

export const WelcomeDescription = styled(UiTypography)`
  text-align: center;
  margin: 8px 16px 16px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 2;
`;
